import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', '923303913396655');
    window.fbq('track', 'PageView');
    // noscript fallback
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=923303913396655&ev=PageView&noscript=1';
    document.body.appendChild(img);
    return () => {
      document.body.removeChild(img);
    };
  }, []);
  return <main className="min-h-screen bg-[#FDF8F0] font-sans text-[#2D2D2D] selection:bg-[#C5A55A] selection:text-[#0F1D33]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <AudienceSection data-id="element-4" />
      <HowItWorksSection data-id="element-5" />
      <FAQSection data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <Footer data-id="element-8" />
    </main>;
}